import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {
    Card,
    CardHeader,
    CardContent,
    CardActions,
    Divider,
    Grid,
    Button,
    Box,
} from '@material-ui/core';
import { Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import { useSnackbar } from 'notistack';
import LinearProgress from '@material-ui/core/LinearProgress';
import { useDictionaryApi } from '../../../api/dictionary';
import { fetchCurrentUser, initUser, UserBase, UserDto } from '../../../api/user';
import Spin from '../../atoms/Spin/Spin';
import FormikTextField from '../../atoms/FormikInput/FormikInput';

const useStyles = makeStyles(() => ({
    root: {},
    progress: {
        height: '4px',
        width: '100%',
        marginBottom: '10px',
    },
}));

const AccountDetails = (props: any) => {
    const { className, ...rest } = props;

    const classes = useStyles();
    const [item, setItem] = useState<UserDto>(initUser());
    const { put } = useDictionaryApi<UserBase>('/users/current');
    const { enqueueSnackbar } = useSnackbar();
    const [loading, setLoading] = useState(false);

    const schema = () =>
        Yup.object().shape({
            username: Yup.string().required('Введите логин'),
            first_name: Yup.string().required('Введите имя'),
            last_name: Yup.string().required('Введите фамилия'),
            phone_number: Yup.string().required('Введите номер телефона'),
            idn: Yup.string().required('Введите ИИН'),
            email: Yup.string().email('Введите корректную почту').required('Введите почту'),
        });

    useEffect(() => {
        setLoading(true);
        fetchCurrentUser()
            .then((res) => {
                setItem(res);
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    return (
        <div>
            {loading && <Spin />}

            <Formik
                enableReinitialize={true}
                initialValues={item}
                validationSchema={schema()}
                onSubmit={(values, { setSubmitting }) => {
                    setSubmitting(true);

                    put({
                        email: values.email,
                        first_name: values.first_name,
                        last_name: values.last_name,
                        idn: values.idn,
                        middle_name: values.middle_name,
                        phone_number: values.phone_number,
                        username: values.username,
                        region: values.region,
                    })
                        .then(() => {
                            enqueueSnackbar('Успешно сохранен', {
                                variant: 'success',
                            });
                        })
                        .catch(() => {
                            enqueueSnackbar('Ошибка при сохранении данных', {
                                variant: 'error',
                            });
                        })
                        .finally(() => setSubmitting(false));
                }}
            >
                {({ isSubmitting, submitForm }) => (
                    <Card {...rest} className={clsx(classes.root, className)}>
                        <CardHeader
                            subheader="Информация может быть редактирована"
                            title="Профиль"
                        />
                        <Divider />
                        <CardContent>
                            <Form className={classes.root}>
                                <Grid container spacing={3}>
                                    <Grid item md={6} xs={12}>
                                        <Field
                                            component={FormikTextField}
                                            fullWidth
                                            label="Имя"
                                            margin="dense"
                                            name="first_name"
                                            value={item.first_name}
                                            variant="outlined"
                                        />
                                    </Grid>
                                    <Grid item md={6} xs={12}>
                                        <Field
                                            component={FormikTextField}
                                            fullWidth
                                            label="Фамилия"
                                            margin="dense"
                                            name="last_name"
                                            value={item.last_name}
                                            variant="outlined"
                                        />
                                    </Grid>
                                    <Grid item md={6} xs={12}>
                                        <Field
                                            component={FormikTextField}
                                            fullWidth
                                            label="Отчество"
                                            margin="dense"
                                            name="middle_name"
                                            value={item.middle_name}
                                            variant="outlined"
                                        />
                                    </Grid>
                                    <Grid item md={6} xs={12}>
                                        <Field
                                            component={FormikTextField}
                                            fullWidth
                                            label="ИИН"
                                            margin="dense"
                                            name="idn"
                                            value={item.idn}
                                            variant="outlined"
                                        />
                                    </Grid>
                                    <Grid item md={6} xs={12}>
                                        <Field
                                            component={FormikTextField}
                                            fullWidth
                                            label="Email"
                                            margin="dense"
                                            name="email"
                                            value={item.email}
                                            variant="outlined"
                                        />
                                    </Grid>
                                    <Grid item md={6} xs={12}>
                                        <Field
                                            component={FormikTextField}
                                            fullWidth
                                            label="Номер телефона"
                                            margin="dense"
                                            name="phone_number"
                                            variant="outlined"
                                        />
                                    </Grid>
                                </Grid>
                            </Form>
                        </CardContent>
                        <CardActions>
                            <Box display="flex" flexDirection="column" width="100%">
                                <div className={classes.progress}>
                                    {isSubmitting && <LinearProgress />}
                                </div>
                                <div>
                                    <Button
                                        color="primary"
                                        disabled={isSubmitting}
                                        onClick={submitForm}
                                        variant="contained"
                                    >
                                        Сохранить
                                    </Button>
                                </div>
                            </Box>
                        </CardActions>
                    </Card>
                )}
            </Formik>
        </div>
    );
};

AccountDetails.propTypes = {
    className: PropTypes.string,
};

export default AccountDetails;
